export enum PromotionPeriod {
  Recurrent = 'Recurrent',
  Definite = 'Definite'
}
